import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../Layouts';

// Routes
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import NonAuthLayout from '../Layouts/NonAuthLayout';
import AuthProtected from './Authprotected';

const PageLoader = () => (
  <div style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    width: "100%",
    color: "#FACC15",
    fontFamily: "'Outfit', sans-serif",
    flexDirection: "column",
    gap: "16px"
  }}>
    <div style={{
      width: "36px",
      height: "36px",
      border: "3px solid rgba(250, 204, 21, 0.15)",
      borderTop: "3px solid #FACC15",
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite"
    }}></div>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
    <span style={{ fontSize: "11px", fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
      Loading Module...
    </span>
  </div>
);

const RoutesComponents = () => {

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>

        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout> {route.component} </NonAuthLayout>}
            // exact={true}
            />
          ))
          }
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected>
                  <Layout>
                    {route.component}
                  </Layout>
                </AuthProtected>
              }
            />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default RoutesComponents;
